module.exports = __webpack_public_path__ + "img/bjnews.7f6891db.png";